import { usePrivacy } from "contexts/privacy";
import { DisplayAmount } from "components/display/amount";
import { maskPrivacyAmount } from "utils/utils";

export const AmountCell = ({ getValue, className = "" }) => {
  const { privacyOn } = usePrivacy();
  let amount = getValue();

  amount = Number(amount);
  if (isNaN(amount) || amount === null || amount === undefined) return null;
  return (
    <div className={className}>
      {privacyOn ? maskPrivacyAmount(amount) : <DisplayAmount value={amount} />}
    </div>
  );
};
